import { gql } from "@apollo/client";

export const UpdateGridAssetRank = gql`
    mutation UpdateGridAssetRank ($id: ID!, $beforeGridAssetId: ID, $afterGridAssetId: ID){
        updateGridAssetRank(id: $id, beforeGridAssetId: $beforeGridAssetId, afterGridAssetId: $afterGridAssetId) {
            id
            title
            visible
        }
    }
`;
